import React from 'react';

import Header from '../../components/user/header/Header.jsx';
import SubIntro from '../../components/user/sub_intro2/Intro.jsx';
import Content from '../../components/user/sub2_1/sub2_1_7/Content.jsx';

import Footer from '../../components/user/footer/Footer.jsx';

import s2_1_7_bg from '../../assets/images/s2_1_7_bg.png';

import '../../styles/user/common.css';
import '../../styles/user/default.css';
import '../../styles/user/fixed.css';
import '../../styles/user/font.css';
import '../../styles/user/footer.css';
import '../../styles/user/header.css';
import '../../styles/user/main.css';
import '../../styles/user/slick-theme.css';
import '../../styles/user/slick.css';
import '../../styles/user/sub.css';

export default function Sub2_1_7() {
  return (
    <>
      <Header />
      <SubIntro
        backgroundImage={s2_1_7_bg}
        mainTitle="멀티플 서빙로봇"
        productName="CREAMBOT"
        productModel="W3"
        description="스마트 딜리버리 어시스턴트
IOT 기술이 접목된 편리한 서빙
"
        theme="light"
      />
      <Content />
      <Footer />
    </>
  );
}
